import { SOCIAL_LINKS } from '../config/navigation'

const SOCIAL_LINK_ITEMS = [
  { label: 'GitHub', href: SOCIAL_LINKS.github, icon: 'GitHub' },
  { label: 'LinkedIn', href: SOCIAL_LINKS.linkedin, icon: 'LinkedIn' },
  { label: 'Email', href: SOCIAL_LINKS.email, icon: 'Email', external: false },
]

export default SOCIAL_LINK_ITEMS
